<div class="side-by-side-tabs position-relative">
  <button type="button" class="close" aria-label="Close" title="Close" (click)="closeModal()">
    <span>&times;</span>
  </button>

  <div class="panel-title"> {{ userEdit ? 'Edit' : userValidate || userReValidate ? 'Validate' :
    'Add' }} Profile</div>

  <mat-tab-group [selectedIndex]="selectedIndex" [formGroup]="userForm" (selectedTabChange)="onTabChange($event)"
    class="-mat-tab-list-d-flex">
    <div class="d-flex w-100">

      <mat-tab label="Identity Details">
        <ng-template mat-tab-label>
          <div class="mat-tab-label-content">Identity Details</div>
          <mat-icon class="material-icons red-color"
            *ngIf="userSubmitted && (userFormValues['name'].invalid || userFormValues['empId'].invalid)">
            highlight_off</mat-icon>
        </ng-template>
        <!--photo div-->
        <div class="field mb-20">
          <div class="position-relative d-flex justify-content-center">
            <div class="pic-display-box">
              <div class="position-relative d-photo-person">
                <img *ngIf="!imgURL" class=" w-100 h-100 card-img-top rounded-circle" alt=""
                  src="../../assets/images/defaultuser.svg" />
                <img *ngIf="imgURL" alt="" [src]="imgURL" class="w-100 h-100 card-img-top rounded-circle">
              </div>
              <div class="text-right align-helmet cursor" *ngIf="!imgURL"
                (click)="imageInput.value=''; imageInput.click()"><em class="fas fa-camera camera-icon"></em>
              </div>
              <div class="text-right align-helmet cursor" *ngIf="imgURL" (click)="deleteImage()">
                <em class="fas fa-trash-alt camera-icon"></em>
              </div>
            </div>
          </div>
          <input #imageInput type="file" (change)="onImageSelected($event)" style="display:none;">
        </div>
        <!--Photo div ends-->
        <app-name-form formControlName="name"></app-name-form>

        <div class="modal-form d-flex">
          <mat-form-field>
            <mat-label>EmpId</mat-label>
            <input matInput formControlName="empId">
            <ng-container *ngIf="userSubmitted && userFormValues['empId'].errors">
              <mat-error *ngIf="userFormValues['empId'].errors?.['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>EmpId is required
              </mat-error>
              <mat-error *ngIf="userFormValues['empId'].errors?.['pattern']">
                <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>

        <div class="btn-basket">
          <button mat-raised-button color="primary" (click)="stepChange('next')">
            <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
          </button>
        </div>
      </mat-tab>
    </div>

    <mat-tab label="Personal Details">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Personal Details</div>
        <mat-icon class="material-icons red-color" *ngIf="userSubmitted && userFormValues['personalInfo'].invalid">
          highlight_off</mat-icon>
      </ng-template>
      <app-personal-info-form formControlName="personalInfo"></app-personal-info-form>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="stepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button mat-raised-button color="primary" (click)="stepChange('next')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
        </button>
      </div>
    </mat-tab>

    <mat-tab label="Contact Details">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Contact Details</div>
        <mat-icon class="material-icons red-color" *ngIf="userSubmitted && userFormValues['contact'].invalid">
          highlight_off</mat-icon>
      </ng-template>
      <app-contact-form formControlName="contact" pageType="people"></app-contact-form>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="stepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button mat-raised-button color="primary" (click)="stepChange('next')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
        </button>
      </div>

    </mat-tab>

    <mat-tab label="Assignments">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Assignments</div>
        <mat-icon class="material-icons red-color"
          *ngIf="userSubmitted && (userFormValues['roleId'].invalid || userFormValues['tradeId'].invalid )">
          highlight_off</mat-icon>
      </ng-template>
      <mat-form-field>
        <mat-label>Role</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="roleId">
          <mat-option class="text-capitalize" *ngFor="let option of roleList" [value]="option._id" selected>
            {{option.roleName | titlecase}}
          </mat-option>
        </mat-select>
        <ng-container *ngIf="userSubmitted && userFormValues['roleId'].errors">
          <mat-error *ngIf="userFormValues['roleId'].errors?.['required']">
            <em class="fas fa-exclamation-circle mr-2"></em>Role is required
          </mat-error>
        </ng-container>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Trade</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="tradeId">
          <mat-option class="text-capitalize" *ngFor="let option of tradeList" [value]="option._id" selected>
            {{option.tradeName | titlecase}}
          </mat-option>

        </mat-select>
        <ng-container *ngIf="userSubmitted && userFormValues['tradeId'].errors">
          <mat-error *ngIf="userFormValues['tradeId'].errors?.['required']">
            <em class="fas fa-exclamation-circle mr-2"></em>Trade is required
          </mat-error>
        </ng-container>
      </mat-form-field>
      <div [ngClass]="userFormValues['siteId'].value?'make-responsive':''">
        <mat-form-field>
          <mat-label>{{ 'plant' | translate }}</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="siteId">
            <mat-option class="text-capitalize" *ngFor="let option of plantList" [value]="option._id" selected
              (onSelectionChange)="showSupervisorList($event)">
              {{option.name | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-checkbox class="example-margin" formControlName="restrictedAccess" *ngIf="userFormValues['siteId'].value">
          Restricted Entry Access</mat-checkbox>
      </div>
      <mat-form-field *ngIf="showSupervisor">
        <mat-label>Supervisor</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="supervisor">
          <mat-option class="text-capitalize" *ngFor="let option of supervisorList" [value]="option._id" selected>
            {{option.name['first']}}
            {{option.name['middle']}} {{option.name['last']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="stepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button mat-raised-button color="primary" (click)="stepChange('next')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
        </button>
      </div>
    </mat-tab>

    <mat-tab label="User Credentials">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">User Credentials</div>
        <mat-icon class="material-icons red-color"
          *ngIf="userSubmitted && userFormValues['userGroup'].invalid || (userSubmitted && ((userNameAvailable==null && toggle) || userFormValues['userName'].invalid))">
          highlight_off</mat-icon>
      </ng-template>
      <div class="make-responsive">
        <mat-form-field>
          <mat-label>Username</mat-label>
          <input (keyup)="checkUsername($event)" matInput formControlName="userName" (keypress)="omit_special_char($event)"
            (keydown.space)="$event.preventDefault()">
          <ng-container *ngIf="userSubmitted && userFormValues['userName'].errors">
            <mat-error *ngIf="userFormValues['userName'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Username is required
            </mat-error>
          </ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>IDM Username</mat-label>
          <input (keyup)="checkidmUserName($event)" matInput formControlName="idmUserName"
            (keypress)="omit_special_char($event)" (keydown.space)="$event.preventDefault()">
        </mat-form-field>
      </div>
      <div *ngIf="userAdd ||  userData?.['credentials'].length==0" class="position-relative mb-3 mt-2">
        <button class="checkAvailability" [disabled]="disableAvailableCheck" type="button"
          (click)="checkAvailablility()"
          [ngClass]="{'greenBtn' :userNameAvailable==true, 'redBtn':userNameAvailable==false}">{{showText}}
        </button>
        <div *ngIf="userSubmitted && userNameAvailable==null && toggle" class="err-mssg"><em
            class="fas fa-exclamation-circle mr-2"></em>Please check username availability</div>
      </div>

      <mat-form-field *ngIf="toggle ||  userData?.['credentials'].length>0">
        <mat-label>Privilege</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="userGroup">
          <mat-option *ngFor="let userType of userGroupList" [value]="userType._id">
            {{userType?.name}}
          </mat-option>
        </mat-select>
        <ng-container *ngIf="userSubmitted && userFormValues['userGroup'].errors">
          <mat-error *ngIf="userFormValues['userGroup'].errors?.['required']">
            <em class="fas fa-exclamation-circle mr-2"></em>User group is required
          </mat-error>
        </ng-container>
      </mat-form-field>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="stepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button *ngIf="userValidate || userReValidate" mat-raised-button color="primary" (click)="stepChange('next')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
        </button>
        <button *ngIf="userEdit && isRevoke && userData?.credentials[0]?.userName" mat-raised-button color="primary"
          (click)="onResetRevoke('revoke')">
          Revoke
        </button>
        <button *ngIf="userEdit && userData?.credentials[0]?.userName" mat-raised-button color="primary"
          (click)="onResetRevoke('reset')">
          Reset
        </button>
        <button *ngIf="!userValidate && !userReValidate" mat-raised-button color="primary"
          (click)="onSubmit(userValidate ? 'accept' : 'null')">
          {{ userValidate ? 'Approve':userReValidate ? 'Approve' : 'Submit' }}
        </button>
      </div>
    </mat-tab>

    <mat-tab label="Remarks" *ngIf="userValidate || userReValidate">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Remarks</div>
        <mat-icon class="material-icons red-color" *ngIf="userSubmitted && userFormValues['remarks'].invalid">
          highlight_off</mat-icon>
      </ng-template>
      <div class="disabled" *ngIf="userData?.userComments">
        User comment:&nbsp;&nbsp;{{userData?.userComments}}
      </div>
      <div class="disabled" *ngIf="userData?.approverComments">
        Approver comment:&nbsp;&nbsp;{{userData?.approverComments}}
      </div>
      <div class="-text-area-field-height">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Leave a comment</mat-label>
        <textarea formControlName="remarks" matInput></textarea>
        <ng-container *ngIf="userSubmitted && userFormValues['remarks'].errors">
          <mat-error *ngIf="userFormValues['remarks'].errors?.['required']">
            <em class="fas fa-exclamation-circle mr-2"></em>Remarks is required
          </mat-error>
          <mat-error *ngIf="userFormValues['remarks'].errors?.['pattern']">
            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
          </mat-error>
        </ng-container>
      </mat-form-field>
      </div>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="stepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button *ngIf="userValidate" mat-raised-button color="primary" (click)="onSubmit('rejected')">
          Reject
        </button>
        <button mat-raised-button color="primary" (click)="onSubmit(userValidate || userReValidate ? 'accept': 'null')">
          {{ userValidate ? 'Approve':userReValidate ? 'Approve' : 'Submit' }}
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="red-color" style="text-align: center;">{{errorMsg}}</div>
</div>